import { useAnalytics } from 'ia-react-core';
import { useCallback } from 'react';
import logger from '../../../../utils/logger';

const useHandleOnFailure = () => {
  const { track } = useAnalytics();
  const useHandleOnFailureForm = useCallback((errorMsg: string) => {
    track({
      event: new MouseEvent('click'),
      scope: 'Change Password',
      values:
      {
        change: errorMsg,
      },
    });
    logger.error(`Change Password Fail:${errorMsg} Authentication returned error.`);
  }, [track]);

  return useHandleOnFailureForm;
};

export default useHandleOnFailure;
